<template>
  <div class="col-xl-12 col-lg-12">
    <div class="contact-head">
      <div class="row align-items-center">
        <div class="col-sm-6">
          <ul class="contact-breadcrumb">
            <li>
              <router-link to="/crm/reports-list">
                <i class="ti ti-arrow-narrow-left"></i> List
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body settings-form">
        <form class="toggle-height">
          <div class="pro-create">
            <div class="button-group-container col-md-12">
              <div class="col-md-7">
                <div class="col-md-12">
                  <p style="text-transform: capitalize; margin-bottom: 10px;">{{ moduleName }}</p>
                  <h3>{{ reportName }}</h3>
                </div>
              </div>
              <div class="col-md-5 button-group">
                <div class="text-end">
                  <button class="btn btn-info px-3" @click.prevent="reportEdit">Overview Configuration</button>
                </div>

                <div class="filter-set-view" v-if="data?.length > 0" ref="dropdown">
                  <div class="filter-set-head filter-btn">
                    <button @click.prevent="toggleAccordion" class="btn btn-light"><i
                        class="ti ti-filter-share me-2"></i>Filter</button>
                    <div class="accordion filter-drop-down" id="accordionExample" v-if="showAccordion">
                      <div class="filter-set-content">
                        <div class="filter-set-contents accordion-collapse collapse show" id="collapseTwo"
                          data-bs-parent="#accordionExample">
                          <div class="filter-content-list">
                            <div class="form-wrap icon-form">
                              <span class="form-icon"><i class="ti ti-search"></i></span>
                              <input type="text" class="form-control" placeholder="Search Columns"
                                v-model="searchTerm" />
                            </div>
                            <ul>
                              <li v-for="colName in filteredColumnOptions" :key="colName.value">
                                <div class="filter-checks">
                                  <label class="checkboxs"
                                    :class="{ 'disabled-label': selectedColumns.length === 1 && selectedColumns.includes(colName.value) }"
                                    @click.prevent="handleColumnSelection(colName.value)">
                                    <input type="checkbox" class="disabled-checkbox" :id="'checkbox-' + colName.value"
                                      :checked="selectedColumns.includes(colName.value)"
                                      :disabled="selectedColumns.length === 1 && selectedColumns.includes(colName.value)"
                                      @click.stop />
                                    <span class="checkmarks"></span>
                                  </label>
                                </div>
                                <div class="collapse-inside-text">
                                  <h5 :for="'checkbox-' + colName.value" @click="handleColumnSelection(colName.value)"
                                    :class="{ 'disabled-label': selectedColumns.length === 1 && selectedColumns.includes(colName.value) }">
                                    {{ colName.label }}
                                  </h5>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="dropdown" v-if="data?.length > 0">
                  <button class="btn btn-light dropdown-toggle" type="button" id="dropdownMenuButton"
                    data-bs-toggle="dropdown" aria-expanded="false">
                    Actions
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <li>
                      <a class="dropdown-item" href="#" @click.prevent="exportData"><i
                          class="ti ti-download me-1"></i>Export</a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="#" @click.prevent="handleModify"><i
                          class="ti ti-pencil me-1"></i>Modify</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>


  <!-- Scrollable Table -->
  <div class="table-container" v-if="data.length > 0">
    <div class="m-2 text-md font-medium">
      Total Records: {{ pagination.total }}
    </div>
    <a-table class="stripped table-hover" :columns="filteredColumns" :data-source="data" :pagination="false"
      @change="handleTableSortChange">
      <template #bodyCell="{ column, record }">
        <template v-if="column.field === 'org_name'">
          <a :href="$router.resolve({
            path: '/crm/create-organisation',
            query: {
              ter_Id: record.organization_territory_id, org_Id: record.org_id
            },
          }).href" target="_blank">
            <span>{{ record.org_name }}</span>
          </a>
        </template>

        <template v-else-if="column.field === 'org_unique_code'">
          <a :href="$router.resolve({
            path: '/crm/create-organisation',
            query: {
              ter_Id: record.organization_territory_id, org_Id: record.org_id
            },
          }).href" target="_blank">
            <span>{{ record.org_unique_code }}</span>
          </a>
        </template>

        <template v-else-if="column.field === 'opp_meter_opportunity_nr_auto'">
          <a :href="$router.resolve({
            path: `/crm/meter-opportunities-edit/${record.opp_id}`
          }).href" target="_blank">
            <span>{{ record.opp_meter_opportunity_nr_auto }}</span>
          </a>
        </template>

        <template v-else-if="column.field === 'con_contract_number'">
          <a :href="$router.resolve({
            path: `/crm/edit-contract/${record.con_id}`
          }).href" target="_blank">
            <span>{{ record.con_contract_number }}</span>
          </a>
        </template>

        <template v-else-if="column.field === 'org_logs'">
          <span class="d-inline-block text-truncate" :style="{ maxWidth: '200px' }" :title="record.org_logs">
            {{ record.org_logs }}
          </span>
        </template>

        <template v-else-if="column.field === 'opp_logs'">
          <span class="d-inline-block text-truncate" :style="{ maxWidth: '200px' }" :title="record.opp_logs">
            {{ record.opp_logs }}
          </span>
        </template>

        <template v-else-if="column.field === 'con_logs'">
          <span class="d-inline-block text-truncate" :style="{ maxWidth: '200px' }" :title="record.con_logs">
            {{ record.con_logs }}
          </span>
        </template>

        <template v-else>
          <div>
            <span class="text-capitalize">{{ record[column?.field] }}</span>
          </div>
        </template>
      </template>
    </a-table>
  </div>
  <div v-else class="no-data-container">
    <i class="no-data-icon">📄</i>
    <p class="no-data-message">No Data Found</p>
  </div>

  <!-- Fixed Pagination -->
  <div class="pagination-container" v-if="data.length > 0">
    <a-pagination :current="pagination.current" :pageSize="pagination.pageSize" :total="pagination.total"
      @change="handleTableChange" class="d-flex" showSizeChanger :pageSizeOptions="pageSizeOptions" />
  </div>

  <!-- Prompt User Modal -->
  <Popup v-if="module_data.length > 0" :content="module_data" :generateReport="generateReport" />

  <div ref="modifyReport" class="modal fade" id="modify_model" tabindex="-1" role="dialog"
    aria-labelledby="modifyReport" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border-0 m-0 justify-content-end">
          <h5><i class="ti ti-report me-2"></i>Modify</h5>
          <button class="btn-close" id="close-btn" data-bs-dismiss="modal" aria-label="Close" @click="cancel_change">
            <i class="ti ti-x"></i>
          </button>
        </div>
        <div class="modal-body confirm">
          <h5 class="mb-3">This action cannot be undone!</h5>
          <Form class="toggle-height">
            <div class="pro-create">
              <div class="mb-3">
                <div class="form-row">
                  <div class="mb-3">
                    <treeselect v-model="form.field_id" :options="modify_module_data" :disable-branch-nodes="true"
                      :show-count="true" @update:modelValue="handleClear"
                      @select="(selectedNode) => handleSelectChange(selectedNode)" placeholder="Choose field...." />
                  </div>

                  <div v-if="
                    fieldType === 'dropdown' &&
                    dropdown_options
                  ">
                    <select class="form-select form-control custom_form_select py-0" v-model="form.value"
                      @change="handleDropDown">
                      <option value="">-----Select-----</option>
                      <option v-for="option in dropdown_options" :key="option.value || option.id"
                        :value="option.value || option.id">
                        {{ option.text || option.name || option.country_name }}
                      </option>
                    </select>
                  </div>
                  <div v-else-if="fieldType === 'text' || fieldType === 'none'">
                    <input type="text" placeholder="Enter value" class="form-control custom_form_select py-0" v-model="form.value
                      " />
                  </div>

                  <div v-else-if="fieldType === 'checkbox'" class="py-3-5">
                    <input type="checkbox" class="form-check custom_form_select" :true-value="1" :false-value="0"
                      v-model="form.value" />
                  </div>

                  <div v-else-if="fieldType === 'textarea'">
                    <textarea class="form-control custom_form_select py-0" v-model="form.value
                      "></textarea>
                  </div>
                  <div v-else-if="fieldType === 'datepicker'">
                    <div class="row align-items-center">
                      <div class="col-12">
                        <div class="icon-form">
                          <date-time-picker
                            v-model="form.value"
                            text-input
                            format="dd/MM/yyyy"
                            auto-apply
                            :enable-time-picker="false"
                            :disabled=false
                            :clearable=true
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end">
                <!-- <button class="btn btn-primary" :class="{ 'disabled-label': (!form.field_id || !form.value) }"
                  @click.prevent="confirm_change">
                  Modify
                </button> -->
                <button class="btn btn-primary" :class="{ 'disabled-label': (!form.field_id || !form.value) }"
                  @click.prevent="confirmPrompt">
                  Modify
                </button>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>

  <div ref="confirm_prompt" class="modal fade" id="confirm_prompt_modal" tabindex="-1" role="dialog"
    aria-labelledby="confirmPromptLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border-0 m-0 justify-content-between">
          <h4 class="">This action cannot be undone!</h4>
          <button class="btn-close" id="close-prompt-modal" data-bs-dismiss="modal" aria-label="Close"
            @click.prevent="cancelPrompt">
            <i class="ti ti-x"></i>
          </button>
        </div>
        <div class="modal-body confirm">
          <h5 class="mb-3">Are you sure want to modify the <span class="text-danger">{{ FieldName }}</span> field with
            <span class="text-danger">{{ dropdownOptionName || fieldValue }}</span> value.
          </h5>
          <div class="d-flex justify-content-end">
            <button class="btn btn-primary confirm-btn me-2" @click="confirm_change">
              Confirm
            </button>
            <button class="btn btn-outline-secondary cancel-btn" @click="cancelPrompt">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { ref, computed, onMounted, onBeforeUnmount, getCurrentInstance } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { ErrorMessage, Field, Form } from "vee-validate";
import Popup from './propmt-popup.vue'
import { Modal } from "bootstrap";
import Treeselect from "vue3-treeselect";
import "vue3-treeselect/dist/vue3-treeselect.css";
import { changeFormate } from "@/util";

export default {
  components: {
    Form,
    Field,
    ErrorMessage,
    Popup,
    Treeselect,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const module_data = ref([])
    const modify_module_data = ref([]);
    const data = ref([])
    const columns = ref([]);
    const selectedColumns = ref([]);
    const pagination = ref({ current: 1, pageSize: 100, total: 0 });
    const sorter = ref({ key: '', order: '', field: '' });
    const columnOptions = ref([]);
    const searchTerm = ref("");
    const showAccordion = ref(false);
    const moduleName = ref(route.query.modN || '');
    const reportName = ref(route.query.repN || '');
    const selectedFieldIds = ref([]);
    const modifiedData = ref(null)
    const dropdown = ref(null);
    const dateFormat = "dd/MM/yyyy";
    const form = ref({
      field_id: null,
      value: "",
    })
    const fieldType = ref(null)
    const dropdown_options = ref(null)
    const dropdownOptionName = ref("")

    const savedColumns = computed(() => {
      return store.getters["report/getColumn"];
    });

    const pageSizeOptions = computed(() => {
      let options = [10]; // Default option
      if (pagination.value.total > 10) options.push(20);
      if (pagination.value.total > 20) options.push(50);
      if (pagination.value.total > 50) options.push(100);
      return options;
    });

    const FieldName = ref()
    const fieldValue = ref()
    const fieldId = ref()
    const isCancelling = ref(false);
    const toggleAccordion = () => {
      showAccordion.value = !showAccordion.value;
    };

    const generateReport = async (id, formData = []) => {
      try {
        let modifiedFormData = []
        if (formData.length > 0) {
          formData.map((data) => {
            return data.map((items) => {
              const { module_name, field_name, ...item } = items;
              modifiedFormData.push(item)
            })
          })
          modifiedData.value = modifiedFormData
        }
        const payload = {
          id,
          modifiedData: modifiedData.value,
          page: pagination.value.current,
          pageSize: pagination.value.pageSize,
          sort_field: sorter.value.field || undefined,
          sort_order: sorter.value.order || undefined,
        };
        const responseData = await store.dispatch("report/generateReport", payload);
        data.value = responseData.data;
        const response = module_data.value
        let dynamicColumns = []

        if (response.length > 0) {
          response.map((org) => {
            return org.children.map((item) => {
              const resolvedField = item.label === 'Lead Created At' ? 'org_lead_created_at' : item.field;
              dynamicColumns.push({
                title: `${org.label}/${item.label.toUpperCase()}`,
                field: resolvedField,
                dataIndex: item.id,
                key: item.id,
                sorter: true,
              })

            });
          })

          columns.value = dynamicColumns;

          columnOptions.value = dynamicColumns.map((col) => ({
            id: col.key,
            label: col.title,
            value: col.field,
          }));

          const reportId = route.query.reportId;

          await store.dispatch("report/selectedColumn", reportId);

          if (savedColumns.value?.length === 0) {

            const module_name = route.query.modN;

            const defaultSelectedFields = defaultModuleFields(module_name)

            selectedColumns.value = defaultSelectedFields
              .slice(0, 6)
              .map(option => option.value);

          } else {

            selectedColumns.value = columnOptions.value
              .filter(item => savedColumns.value.includes(item.id))
              .map(item => item.value);
          }

        }

        pagination.value.total = responseData.total;
      } catch (error) {
        console.error("Error fetching report data:", error);
      }
    };

    const defaultModuleFields = (moduleName) => {

      /* This code is for if we need same fields that are in meter opp, org and in contracts */

      let columnKeys;
      if (moduleName === 'organisations') {
        columnKeys = [
          "org_unique_code",
          "org_name",
          "org_postcode",
          "org_responsible",
          "org_fax",
          "org_www",
          // "org_territory_id",
          // "org_status",
          // "org_no_of_employees",
        ];

      } else if (moduleName === 'opportunities') {
        columnKeys = [
          "opp_meter_opportunity_nr_auto",
          "org_name",
          "opp_sales_responsible",
          "opp_pipeline_level",
          // "next_update_latest_date",
          // "next_update_latest_time",
          "opp_opp_type",
          "opp_sc_forecast_or_amended_annual_consumption",
          // "contract_end_date_days",
          // "opp_contract_end_date",
        ];

      } else if (moduleName === 'contracts') {
        columnKeys = [
          "con_contract_number",
          "org_name",
          "opp_cm_responsible",
          "opp_sales_responsible",
          "con_u4b_status",
          "opp_date_of_sale",
          // "opp_sc_forecast_or_amended_annual_consumption",
        ];

      } else {
        return columnOptions.value.filter((item) => item.value.startsWith(moduleName.substring(0, 3)));
      }

      return columnOptions.value.filter((item) => columnKeys.includes(item.value));

      // return columnOptions.value.filter((item) => item.value.startsWith(moduleName.substring(0, 3)));
    };

    const filteredColumns = computed(() => {
      return selectedColumns.value.length === 0 ? columns.value : columns.value.filter(col => selectedColumns.value.includes(col.field));
    });

    // const filteredColumnOptions = computed(() => {
    //   return columnOptions.value.filter(option => option.label.toLowerCase().includes(searchTerm.value.toLowerCase()));
    // });

    const filteredColumnOptions = computed(() => {
      const filtered = columnOptions.value.filter(option =>
        option.label.toLowerCase().includes(searchTerm.value.toLowerCase())
      );

      // Ensure selectedColumns appear first
      const selectedSet = new Set(selectedColumns.value); // Create a Set for fast lookup
      const selected = filtered.filter(option => selectedSet.has(option.value)); // Get selected columns
      const unselected = filtered.filter(option => !selectedSet.has(option.value)); // Get remaining columns

      return [...selected, ...unselected]; // Merge, with selected columns first
    });

    const handleColumnSelection = async (value) => {
      const index = selectedColumns.value.indexOf(value);
      if (index > -1) {
        selectedColumns.value.splice(index, 1);
      } else {
        selectedColumns.value.push(value);
      }
      const selectedIds = columnOptions.value
        .filter(item => selectedColumns.value.includes(item.value))
        .map(item => item.id);

      if (selectedIds.length > 0) {
        const reportId = route.query.reportId
        const payload = {
          id: reportId,
          selected_columns: selectedIds
        }
        const response = await store.dispatch("report/savedColumn", payload);

        if (response.status) {
          await store.dispatch("report/selectedColumn", reportId);
        }

      }

    };

    // const handleTableChange = async (paginationData, filters, sorter) => {
    //   pagination.value.current = paginationData.current;
    //   const reportId = route.query.reportId;
    //   if (reportId) {
    //     await generateReport(reportId);
    //   }
    // };

    const handleTableChange = async (current, pageSize) => {
      pagination.value.current = current;
      pagination.value.pageSize = pageSize;
      const reportId = route.query.reportId;
      if (reportId) {
        await generateReport(reportId);
      }
    };

    const handleTableSortChange = async (pag, filters, sort) => {
      if (sort?.order) {
        sorter.value.key = sort.columnKey;
        sorter.value.order = sort.order === 'ascend' ? 'ASC' : sort.order === 'descend' ? 'DESC' : '';
        const col = columns.value.find((c) => String(c.key) === String(sort.columnKey));
        sorter.value.field = col?.field ?? '';
      } else {
        sorter.value.key = '';
        sorter.value.order = '';
        sorter.value.field = '';
      }
      const reportId = route.query.reportId;
      if (reportId) {
        await generateReport(reportId);
      }
    };

    const exportData = async () => {
      try {
        const reportId = route.query.reportId;
        selectedFieldIds.value = columnOptions.value
          .filter(item => selectedColumns.value.includes(item.value))
          .map(item => item.id);
        const response = await store.dispatch("report/downloadReport", { reportId, columns: selectedFieldIds.value, modifiedData: modifiedData.value });

        if (response && response.data && response.data.url) {
          const fileUrl = response.data.url;
          const link = document.createElement("a");
          link.href = fileUrl;
          link.download = "";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          console.error("Error: Report download failed or no URL found.");
        }
      } catch (error) {
        console.error("Error during report download:", error);
      }
    };

    const reportEdit = () => {
      const reportId = route.query.reportId;
      const moduleId = route.query.moduleId
      router.push({ path: "/crm/report-edit", query: { reportId, moduleId } });
    };

    const fetchModuleData = async (id) => {
      try {
        const data = await store.dispatch("report/fetchModuleData", id);
        module_data.value = data;
      }
      catch (error) {
        console.error("Error fetching report data:", error);
      }
    };

    const fetchModuleDataForModify = async (id) => {
      try {
        const data = await store.dispatch("report/fetchModuleDataForModify", id);
        modify_module_data.value = data;
      }
      catch (error) {
        console.error("Error fetching report data:", error);
      }
    };

    const handleClickOutside = (event) => {
      if (dropdown.value && !dropdown.value.contains(event.target)) {
        showAccordion.value = false;
      }
    };

    const handleModify = async () => {
      form.value = {
        field_id: null,
        value: ""
      }
      fieldType.value = null;
      dropdown_options.value = null;
      dropdownOptionName.value = null
      const field = document.getElementsByClassName("vue-treeselect__single-value");
      if (field?.[0]?.innerHTML) {
        field[0].innerHTML = "Choose field....";
      }
      const modal = new Modal(document.getElementById("modify_model"));
      modal.show();
    };

    const handleSelectChange = (selectedNode) => {
      const field = document.getElementsByClassName("vue-treeselect__single-value");
      if (field?.[0]?.innerHTML) {
        field[0].innerHTML = selectedNode.label;
      }
      form.value.field_id = selectedNode.id;
      FieldName.value = selectedNode.label;
      form.value.value = null;
      dropdownOptionName.value = null
      fieldType.value = selectedNode.field_type;
      dropdown_options.value = selectedNode.dropdown_options;
    };

    // const handleDateChange = (date) => {
    //   form.value.value = new Date(changeFormate(date));
    // };

    const confirm_change = async () => {
      let payload;
      const reportId = route.query.reportId;
      const iso8601Regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
      const dateString = form.value.value instanceof Date
        ? form.value.value.toISOString()
        : String(form.value.value);

      if (iso8601Regex.test(dateString)) {
        const data = {
          field_id: form.value.field_id,
          value: changeFormate(dateString)
        }
        payload = {
          id: reportId,
          formData: data,
          modifiedData: modifiedData.value
        }
      } else {
        payload = {
          id: reportId,
          formData: form.value,
          modifiedData: modifiedData.value
        }
      }
      const response = await store.dispatch(
        "report/modifyReportData",
        payload
      );
      if (response.status) {
        form.value.field_id = null;
        form.value.value = null;
        dropdownOptionName.value = null
        fieldType.value = null;
        dropdown_options.value = null;
        document.getElementById("close-prompt-modal").click();
        await generateReport(reportId);
        const field = document.getElementsByClassName("vue-treeselect__single-value");
        if (field?.[0]?.innerHTML) {
          field[0].innerHTML = "Choose field....";
        }
      }
    };

    const handleClear = (value) => {
      if (!value) {
        form.value.field_id = null;
        form.value.value = null;
        fieldType.value = null;
        dropdown_options.value = null;
        dropdownOptionName.value = null
      }
    };

    const cancel_change = async () => {
      // if (!fieldId.value) {
      //   const field = document.getElementsByClassName("vue-treeselect__single-value");
      //   if (field?.[0]?.innerHTML) {
      //     field[0].innerHTML = "Choose field....";
      //   }
      //   form.value = {
      //     field_id: null,
      //     value: ""
      //   }

      //   fieldType.value = null;
      //   dropdown_options.value = null;
      // }
      document.getElementById("close-btn").click();

    };

    const confirmPrompt = () => {
      fieldValue.value = form.value.value;
      fieldId.value = form.value.field_id;
      document.getElementById("close-btn").click();
      const modal = new Modal(document.getElementById("confirm_prompt_modal"));
      modal.show();
    }

    const cancelPrompt = () => {
      if (form.value.field_id) {
        if (isCancelling.value) return; // Prevent duplicate execution
        isCancelling.value = true;

        setTimeout(() => {
          isCancelling.value = false;
        }, 300);

        document.getElementById("close-prompt-modal").click();
        const modal = new Modal(document.getElementById("modify_model"));
        modal.show();
        form.value.field_id = fieldId.value;
        form.value.value = dropdownOptionName.value ? findIdDropDownID(dropdownOptionName.value) : fieldValue.value;
      } else {
        document.getElementById("close-prompt-modal").click();
      }

    }

    const handleDropDown = () => {

      const option = dropdown_options.value.find(
        (item) => item.id === form.value.value || item.value === form.value.value
      );

      if (option && (option.name || option.text || option.country_name)) {
        dropdownOptionName.value = option.name || option.text || option.country_name;
      }
    };

    const findIdDropDownID = (value)=>{

      const option = dropdown_options.value.find(
        (item) => item.text === value || item.name === value || item.country_name === value
      );

      if (option && (option.id || option.value )) {
        return option.id|| option.value        
      }
    }

    onMounted(() => {
      document.addEventListener("click", handleClickOutside);
    });

    onBeforeUnmount(() => {
      document.removeEventListener("click", handleClickOutside);
    });


    onMounted(async () => {
      const reportId = route.query.reportId;
      const moduleId = route.query.moduleId;
      if (reportId && moduleId) {
        await fetchModuleData(moduleId);
        await fetchModuleDataForModify(moduleId);
      }
    });

    return {
      data,
      pagination,
      columns,
      selectedColumns,
      columnOptions,
      filteredColumns,
      filteredColumnOptions,
      handleTableChange,
      handleTableSortChange,
      handleColumnSelection,
      searchTerm,
      showAccordion,
      toggleAccordion,
      exportData,
      reportEdit,
      moduleName,
      reportName,
      fetchModuleData,
      generateReport,
      modifiedData,
      module_data,
      modify_module_data,
      dropdown,
      handleModify,
      handleSelectChange,
      form,
      fieldType,
      dropdown_options,
      dateFormat,
      // handleDateChange,
      confirm_change,
      handleClear,
      cancel_change,
      savedColumns,
      selectedFieldIds,
      confirmPrompt,
      cancelPrompt,
      FieldName,
      fieldValue,
      fieldId,
      isCancelling,
      pageSizeOptions,
      handleDropDown,
      dropdownOptionName

    };
  },
};
</script>


<style scoped>
.button-group-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.button-group {
  display: flex;
  align-items: center;
  align-items: self-end;
  justify-content: end;
  gap: 30px;
}

.select {
  background-color: white;
  border-radius: 10px;
  padding: 10px;
  padding-bottom: 10px;
}

label {
  padding-bottom: 10px;
}

.filter-btn {
  position: relative;
}

.filter-drop-down {
  width: 350px;
  z-index: 9999;
  position: absolute;
  top: 90%;
  left: -160%;
}

.table-container {
  max-height: 100%, ;
  overflow-y: scroll;
  margin-bottom: 25px;
  /* overflow-x: scroll; */
  /* scrollbar-width: none;  */
}

.table-container::-webkit-scrollbar {
  width: 0;
}

.pagination-container {
  display: flex;
  justify-content: end;
  margin-top: 10px;
  text-align: center;
}

.ant-table-wrapper {
  margin-bottom: 20px !important;
}

.filter-set-contents .filter-content-list ul {
  max-height: 280px !important;
}

.no-data-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  /* border: 1px dashed #ccc; */
  border-radius: 8px;
  background-color: #f9f9f9;
  color: #555;
}

.no-data-icon {
  font-size: 40px;
  margin-bottom: 10px;
  color: #999;
}

.no-data-message {
  font-size: 16px;
  font-weight: 500;
  color: #666;
}

.disabled-label {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
  /* Prevents clicks */
}
</style>
